import WebFont from './webfontloader/webfontloader.js';

// Preload images
const preloadFonts = id => {
    return new Promise((resolve) => {
        WebFont.load({
            google: {
                families: [id]
            },
            active: resolve
        });
    });
};

const randomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

export {
    preloadFonts,
    randomNumber
}